import { Helmet } from "react-helmet-async";
import Blog from "../layout/Blog/Blog";

function BlogPage() {
  return (
    <>
      <Helmet>
        <title>Blog | SoloChat</title>
        <meta name="description" content="Read the latest articles and updates from SoloChat — tips, features, and community stories." />
        <meta property="og:title" content="Blog | SoloChat" />
        <meta property="og:description" content="Read the latest articles and updates from SoloChat — tips, features, and community stories." />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SoloChat" />
        <meta property="og:url" content="https://solochat-website.web.app/blog" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blog | SoloChat" />
        <meta name="twitter:description" content="Read the latest articles and updates from SoloChat — tips, features, and community stories." />
        <link rel="canonical" href="https://solochat-website.web.app/blog" />
      </Helmet>
      <Blog />
    </>
  );
}

export default BlogPage;
